export default __webpack_public_path__ + "static/media/EdixCarlosCV.02474aee.pdf";